class SearchTrendingProducts extends HTMLElement {
  static markerAttr = 'data-search-trending-products';
  static anchorSelector = 'hdt-predictive-search #drawer-search-form .hdt-search-content-title';

  connectedCallback() {
    this.mountedNode = null;
    this.mount();
  }

  disconnectedCallback() {
    this.mountedNode?.remove();
    this.mountedNode = null;
  }

  mount() {
    const anchor = document.querySelector(SearchTrendingProducts.anchorSelector);
    const content = this.firstElementChild;
    if (!anchor || !content) return;

    document.querySelector(`[${SearchTrendingProducts.markerAttr}]`)?.remove();
    content.setAttribute(SearchTrendingProducts.markerAttr, '');
    anchor.insertAdjacentElement('afterend', content);
    this.mountedNode = content;
  }
}

if (!customElements.get('search-trending-products')) {
  customElements.define('search-trending-products', SearchTrendingProducts);
}
